import React, { useEffect, useState } from "react";
import axios from "../../../utills/api";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";

const Widgets = () => {

  const [bookings, setBookings] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    const fetchAllData = async () => {

      try {

        /*
        =====================================
        FETCH BOOKINGS + REVENUE
        =====================================
        */

        const [
          bookingsRes,
          revenueRes
        ] = await Promise.all([

          axios.get("/bookings"),

          axios.get(
            "/revenue/summary?range=year"
          ),

        ]);


        /*
        =====================================
        BOOKINGS
        =====================================
        */

        const bookingsData =
          bookingsRes.data?.bookings ||
          bookingsRes.data?.data ||
          bookingsRes.data ||
          [];


        const bookingsArr =
          Array.isArray(bookingsData)
            ? bookingsData
            : [];


        setBookings(bookingsArr);


        /*
        =====================================
        REVENUE
        SAME LOGIC AS BALANCE OVERVIEW
        =====================================
        */

        const summary =
          revenueRes.data?.summary || {};


        const revenue =
          Number(
            summary.totalRevenue || 0
          );


        console.log(
          "💰 Dashboard Revenue Summary:",
          summary
        );


        console.log(
          "💰 Total Revenue:",
          revenue
        );


        setTotalRevenue(revenue);


      } catch (error) {

        console.error(
          "❌ Error fetching dashboard data:",
          error
        );

        setBookings([]);
        setTotalRevenue(0);

      } finally {

        setLoading(false);

      }

    };


    fetchAllData();


  }, []);


  /*
  =====================================
  TODAY DATE
  =====================================
  */

  const today = new Date();


  const todayStr =
    today.toISOString().split("T")[0];


  /*
  =====================================
  TOTAL BOOKINGS
  =====================================
  */

  const totalBookings =
    bookings.length;


  /*
  =====================================
  UPCOMING CHECK-IN
  =====================================
  */

  const upcomingCheckIn =
    bookings.filter((b) =>

      b.status
        ?.toLowerCase()
        .trim() === "pending"

    ).length;


  /*
  =====================================
  TODAY'S CHECKOUT
  =====================================
  */

  const todaysCheckout =
    bookings.filter((b) => {

      if (!b.checkOut) {
        return false;
      }


      const checkOutDate =
        new Date(b.checkOut);


      const checkOutStr =
        checkOutDate
          .toISOString()
          .split("T")[0];


      return (
        checkOutStr === todayStr
      );

    }).length;


  /*
  =====================================
  DASHBOARD WIDGETS
  =====================================
  */

  const ecomWidgets = [

    {
      id: 1,
      label: "Total Bookings",
      counter: totalBookings,
      link: "View all bookings",
      icon: "bx bx-list-ul",
      color: "#007bff",
      bgColor:
        "rgba(0, 123, 255, 0.1)",
    },


    {
      id: 2,
      label: "Upcoming Check-In",
      counter: upcomingCheckIn,
      link: "View pending check-ins",
      icon: "bx bx-log-in-circle",
      color: "#28a745",
      bgColor:
        "rgba(40, 167, 69, 0.1)",
    },


    {
      id: 3,
      label: "Today's Checkout",
      counter: todaysCheckout,
      link: "View today's checkouts",
      icon: "bx bx-calendar-check",
      color: "#ffc107",
      bgColor:
        "rgba(255, 193, 7, 0.15)",
    },


    {
      id: 4,
      label: "Revenue",
      counter: totalRevenue,
      link: "View revenue details",
      icon: "bx bx-rupee",
      prefix: "₹",
      decimals: 2,
      color: "#dc3545",
      bgColor:
        "rgba(220, 53, 69, 0.1)",
    },

  ];


  return (

    <Row className="d-flex justify-content-between flex-nowrap">

      {loading ? (

        <p className="text-center text-muted">
          Loading dashboard...
        </p>

      ) : (

        ecomWidgets.map((item) => (

          <Col
            xl={3}
            md={3}
            sm={6}
            key={item.id}
          >

            <Card className="border-0 bg-white">

              <CardBody className="d-flex align-items-center justify-content-between">

                <div>

                  <p className="text-uppercase fw-semibold text-muted mb-1">

                    {item.label}

                  </p>


                  <h4 className="fs-22 fw-bold text-dark mb-3">

                    {item.prefix || ""}

                    <CountUp
                      start={0}
                      end={
                        Number(
                          item.counter
                        ) || 0
                      }
                      duration={1.4}
                      separator=","
                      decimals={
                        item.decimals || 0
                      }
                    />

                  </h4>


                  <Link
                    to="#"
                    className="text-decoration-underline text-muted small"
                  >

                    {item.link}

                  </Link>

                </div>


                <div

                  className="d-flex align-items-center justify-content-center"

                  style={{

                    backgroundColor:
                      item.bgColor,

                    borderRadius:
                      "0.5rem",

                    width:
                      "48px",

                    height:
                      "48px",

                  }}

                >

                  <i

                    className={
                      item.icon
                    }

                    style={{

                      color:
                        item.color,

                      fontSize:
                        "1.5rem",

                    }}

                  />

                </div>

              </CardBody>

            </Card>

          </Col>

        ))

      )}

    </Row>

  );

};


export default Widgets;